// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__+7Oi0","image":"NotFound_image__ZAWbc"};